import { renderDefaultFallback } from '../fallbacks.js';
export const renderFallback = (context, options) => {
    options.onDiagnostic?.({
        type: 'fallback',
        block: context.block,
        kind: context.kind,
        reason: context.reason,
    });
    return options.renderFallback ? options.renderFallback(context) : renderDefaultFallback(context);
};
export const fallbackMessage = (block, message) => message || `Renderer unavailable for block "${block.type}"`;
